<template>
	<span v-if="visible" class="switch" :class="extraClasses" @click.prevent.stop="switchMe" v-bind="tabindexBinding()"><span class="switch-knob"></span></span>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed} from "vue";
import type {Switch} from "@t/fd/editor/Switch";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const {visible, value, clazz, style, ro, tabindexBinding} = useEditor(props);

const extraClasses = computed(() => {
	const clss = [];
	if (ro.value) clss.push("disabled-switch");
	if (enabled.value) clss.push("on");
	return clss;
});

const enabled = computed({
	get() {
		return !!value.value;
	},
	set(val) {
		value.value = !!val;
	},
});

function switchMe() {
	if (!ro.value) enabled.value = !enabled.value;
}
</script>

<style>

</style>
